module.exports = __webpack_public_path__ + "media/creativeMedia/panel06-87ed4c36.png";